import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ListenAPI {
  private _api: string;
  constructor(private readonly _http: HttpClient) {
    this._api = localStorage.getItem('LISTEN_API');
  }

  public listen(layer: any, data: any, orgId: string): Observable<any> {
    return this._http.get(`${this._api}/api/${orgId}/cad/${data.id}`, {
      headers: {
        'X-API-KEY': layer.meta.listen?.apiKey,
      },
    });
  }

  public recordedCalls(layer: any, data: any, orgId: string): Observable<any> {
    return this._http.get(`${this._api}/api/${orgId}/calls/${data.id}/url`, {
      headers: {
        'X-API-KEY': layer.meta.listen?.apiKey,
      },
    });
  }
}
